/**
 * Who built it (D-222, amended D-224 and D-228).
 *
 * <b>One component, two shells.</b> The words and the address were written out
 * twice — once in the public footer and once in the signed-in one — which is two
 * places to update and one of them to forget. They are literals rather than
 * content (D-224): A-16 exists so the studio never needs a developer to change
 * <em>its own</em> words, and these are not the studio's words.
 *
 * <b>The tone differs, and only the tone.</b> Out there it is a shop window and
 * the credit carries its bronze; in here it is a tool somebody works in all
 * evening, so it sits in the faintest ink and gets out of the way.
 */

/*
 * The apex, not www (D-228).
 *
 * www 301s here, so linking to it would spend a redirect on every click for
 * nothing. Singular "innovation" in the domain, plural "Innovations" in the
 * business name — which is a genuine trap, and the reason the address is
 * asserted in a test rather than only read.
 */
const HREF = 'https://isiinnovation.com'
const WORDS = 'Site by ISI Innovations LLC'

export default function BuildCredit({ tone }: { tone: 'bronze' | 'quiet' }) {
  return (
    <a
      href={HREF}
      /*
       * A new tab, and the rel that must come with it.
       *
       * Nobody clicking a credit means to leave the studio's site — a parent
       * mid-way through finding a class least of all. `noopener` also denies the
       * opened page a handle on this one, which is a plain security default
       * rather than a preference.
       */
      target="_blank"
      rel="noopener noreferrer"
      className={
        tone === 'bronze'
          ? 'ml-auto rounded-sm font-medium tracking-[0.04em] text-credit hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-credit'
          : 'mt-auto rounded-sm px-5 py-6 text-right text-[11.5px] text-ink-3 hover:text-ink-2 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink-3'
      }
    >
      {WORDS}
    </a>
  )
}
